import { GetPresignedUrl } from 'domain/usecases/surgical-order/get-presigned-url'

type PresignedUrlRepository = {
  getPresignedUrl(
    params: GetPresignedUrl.Params
  ): Promise<GetPresignedUrl.Model>
}

export class RemoteGetPresignedUrl implements GetPresignedUrl {
  constructor(
    private readonly presignedUrlRepository: PresignedUrlRepository
  ) {}

  get(params: GetPresignedUrl.Params): Promise<GetPresignedUrl.Model> {
    return this.presignedUrlRepository.getPresignedUrl(params)
  }
}
